export const HUB_SETTINGS = {
  RECENTLY_USED_MODULES: 'CustomModules:recentlyUsedModules'
};
export const HUB_SETTINGS_AS_ARRAY = Object.keys(HUB_SETTINGS).map(key => HUB_SETTINGS[key]);